import { WarningIcon, typography } from '@ui';

import * as css from './ErrorScreen.css';
import { ReactNode, useEffect } from 'react';

type ErrorScreenProps = {
    message: string;
    onMount?: (() => void) | (() => Promise<void>);
    action?: ReactNode;
};

export const ErrorScreen = ({ message, onMount, action }: ErrorScreenProps) => {
    useEffect(() => {
        onMount?.();
    }, [onMount]);

    return (
        <div className={css.root}>
            <div className={css.layout}>
                <WarningIcon size={48} />
                {message && <span className={typography({ variant: 'h4' })}>{message}</span>}
                {action}
            </div>
        </div>
    );
};
